import { Controller } from '@hotwired/stimulus'

// Automatically grows a textarea to fit its content, used by the new
// design-system textarea component.
export default class extends Controller {
  connect() {
    this.resize()
  }

  resize() {
    this.element.style.height = 'auto'
    this.element.style.height = `${this.element.scrollHeight}px`
  }
}
